module.exports = __webpack_public_path__ + "img/sad-face.488060c2.svg";